import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { finalize } from 'rxjs/operators';
import { ProviderSite } from '../../../../../core/models/provider-parking/provider-site.model';
import { ApiProviderSiteService } from '../../../../../core/services/api/provider-parking/api-provider-site.service';
import { optionResponse } from '../../../../../core/models/form.model';
import { ApiProviderParkingService } from '../../../../../core/services/api/provider-parking/api-provider-parking.service';
import { ApiTableService } from '../../../../../core/services/api-table.service';

@Component({
  selector: 'app-modal-provider-site',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-provider-site.component.html',
  styleUrl: './modal-provider-site.component.css'
})
export class ModalProviderSiteComponent implements OnInit {
  @Input() siteData: ProviderSite | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  public isLoading: boolean = false;
  public isEditMode: boolean = false;
  public openDropdown: string | null = null;

  // Form Data
  public formData: ProviderSite = this.getInitialFormData();

  // Dropdown Lists
  public providersList: optionResponse | null = null;
  public siteList: optionResponse | null = null;
  public vehicleTypes = ['รถยนต์', 'จักรยานยนต์', 'รถบรรทุก', 'อื่นๆ'];

  // Image Previews
  public images: (string | ArrayBuffer | null)[] = [null, null, null, null];

  constructor(
    private apiProviderSiteService: ApiProviderSiteService,
    private apiProviderParkingService: ApiProviderParkingService,
    private apiTableService: ApiTableService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.fetchOptions();
    if (this.siteData) {
      this.isEditMode = true;
      this.formData = { ...this.siteData };
    } else {
      this.isEditMode = false;
      this.formData = this.getInitialFormData();
    }
  }

  private getInitialFormData(): ProviderSite {
    return {
      id: 0,
      name: '',
      lot: 0,
      providerName: '',
      vehicleType: '',
      isOnline: false,
      site: ''
    };
  }

  private fetchOptions(): void {
    // Fetch Providers
    this.apiProviderParkingService.getProviderList().subscribe({
      next: (res) => this.providersList = res,
      error: (err) => console.error('Fetch providers error:', err)
    });

    // Fetch Sites
    this.apiTableService.getParkingSiteList().subscribe({
      next: (res) => this.siteList = res,
      error: (err) => console.error('Fetch sites error:', err)
    });
  }

  // --- Dropdown Logic ---
  public toggleDropdown(id: string, event: Event): void {
    event.stopPropagation();
    this.openDropdown = this.openDropdown === id ? null : id;
  }

  public selectOption(field: keyof ProviderSite, value: any): void {
    (this.formData as any)[field] = value;
    this.openDropdown = null;
  }

  public onMoreSelect(type: string): void {
    console.log('Opening more details for:', type);
    // Logic for advanced picking
  }

  // --- File Handling ---
  public triggerFileInput(id: string): void {
    const element = document.getElementById(id);
    if (element) element.click();
  }

  public onFileChange(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.images[index] = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  // --- Actions ---
  public onSave(): void {
    if (!this.validateForm()) return;

    this.isLoading = true;
    this.apiProviderSiteService.createProviderSite(this.formData)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (res) => {
          this.toast.success('บันทึกข้อมูลพื้นที่ให้บริการสำเร็จ');
          this.saveSuccess.emit();
          this.onClose();
        },
        error: (err) => {
          console.error('Save error:', err);
          this.toast.error('ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        }
      });
  }

  public onClose(): void {
    this.close.emit();
  }

  public closeAllDropdowns(): void {
    this.openDropdown = null;
  }

  private validateForm(): boolean {
    if (!this.formData.name.trim()) {
      this.toast.error('กรุณากรอกชื่อพื้นที่ให้บริการ');
      return false;
    }
    if (!this.formData.providerName) {
      this.toast.error('กรุณาเลือกผู้ให้บริการ');
      return false;
    }
    return true;
  }
}
